const getSortedData = <T extends string | { name: string; _id?: string }>(
  arrayData: T[],
): T[] => {
  if (arrayData.length === 0) return arrayData;

  const globalView = arrayData.find(
    (item) => typeof item === 'object' && item._id === '',
  );
  const sortedData = arrayData
    .filter((item) => !(typeof item === 'object' && item._id === '')) // Exclude 'Global View' from sorting
    .sort((a, b) => {
      if (typeof a === 'object' && typeof b === 'object') {
        return a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      } else if (typeof a === 'string' && typeof b === 'string') {
        return a.localeCompare(b, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      }
      return 0;
    });

  // Place 'Global View' at the beginning if found
  if (globalView) {
    return [globalView, ...sortedData];
  }
  return sortedData;
};

export default getSortedData;
